export const DASH_BOARD_RIGHT_WIDTH = 124

export const DEFAULT_HEIGHT = 60;

export const DASHBOARD_LEFT = '#F9FAFB'
export const ROLE_ADMIN = "ADMINISTRATOR" // 管理者モード

export const HEADER_MAIN_COLOR = '#4572c4'
export const HEADER_COLOR = 'linear-gradient(to bottom, #4572c4 0%, #4572c4 100%)'
export const MAIN_HEADER_COLOR = 'linear-gradient(to bottom, #e8f4f8 0%, white 100%)'
export const MAIN_HEADER_COLOR_TOP = 'linear-gradient(to bottom, #e8f4f8 0%, white 10%)'
export const CONTENT_COLOR = '#4572c4'
export const TABLE_BLUE_COLOR = '#d9e1f2'
export const SCROLL_ARROW_COLOR = '#dae8fc'
export const BUTTON_BLUE_COLOR = '#2396fc'
export const BOX_GRAY_COLOR = '#343a40'
export const BUTTON_GRAY_COLOR = '#6c767d'
export const BUTTON_WHITE = '#e9ecef'
export const BLUE_BUTTON_COLOR = '#0085fc'
export const BACKGROUND_DELETE_BUTTON_HOVER = '#0085fc'
export const BACKGROUND_DELETE_BUTTON = '#0085fc'
export const BACKGROUND_BUTTON_HOVER = '#0085fc'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
    PaperProps: {
    style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
    },
    },
};

export const WIDTH_DASHBOARD_LEFT = '148px'
export const WIDTH_AGGRID = 'calc(100% - 148px)'
